var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.028 21.97H.942A.942.942 0 010 21.027V7.218c0-.173.14-.313.314-.313h21.342c.173 0 .313.14.313.314v3.628c0 .173-.454 8.612-.627 8.612-.174 0 0-8.44 0-8.612V7.532H.628v13.496c0 .173.14.314.314.314h20.086c.173 0 .314-.14.314-.314v-1.745c0-.07-.029-1.265-.051-2.662-.033-2.051-.052-4.538.05-4.538.174 0 .628 7.026.628 7.2v1.745c0 .52-.421.941-.941.941z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.656 7.532H.314A.314.314 0 010 7.22v-4.08c0-.52.422-.942.942-.942h2.903a.314.314 0 010 .628H.942a.314.314 0 00-.314.313v3.767h20.714V3.138a.314.314 0 00-.314-.313h-2.903a.314.314 0 110-.628h2.903c.52 0 .941.421.941.941v4.08c0 .174-.14.314-.313.314z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.928 2.825H6.042a.314.314 0 010-.628h9.886a.314.314 0 110 .628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.026 5.022c-.78-.001-1.411-.633-1.412-1.413V1.412a1.412 1.412 0 112.825 0V3.61c-.001.78-.633 1.412-1.413 1.413zm0-4.394a.785.785 0 00-.784.784V3.61a.785.785 0 001.569 0V1.412a.785.785 0 00-.785-.784zM4.943 5.022c-.78-.001-1.411-.633-1.412-1.413V1.412a1.412 1.412 0 012.824 0V3.61c0 .78-.632 1.412-1.412 1.413zm0-4.394a.785.785 0 00-.785.784V3.61a.785.785 0 001.57 0V1.412a.785.785 0 00-.785-.784z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 5.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 8.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 10.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 13.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 16.5,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 0.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 2.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2C50FF",
    cx: 5.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 8.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 10.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 13.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 16.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 0.5,
    cy: 6.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 2.5,
    cy: 6.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 5.5,
    cy: 6.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 8.5,
    cy: 6.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 10.5,
    cy: 6.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 13.5,
    cy: 6.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 16.5,
    cy: 6.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 0.5,
    cy: 9.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 2.5,
    cy: 9.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 5.5,
    cy: 9.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 8.5,
    cy: 9.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 10.5,
    cy: 9.5,
    r: 1
  })))));
}

export default SvgCalendar;